import { Grid, Typography } from '@mui/material'
import React from 'react'
import { ControlledTextField } from '../ControlledTextField'
import { FieldContainer } from '../FieldContainer'

export const ContactFields = ({ disableEmail = false }) => {
  return (
    <FieldContainer>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant='h6'>Contact</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledTextField
            name='contact.name'
            label='Name'
            helperText='First Name Last Name'
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledTextField
            name='contact.email'
            label='Email'
            disabled={disableEmail}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ControlledTextField
            name='contact.mobile'
            label='Mobile'
            helperText='Example: +639876543210'
          />
        </Grid>
      </Grid>
    </FieldContainer>
  )
}
